import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import CurrentUserContext from 'providers/CurrentUser';
import { generateAuthPath } from './utils/generateAuthPath';

import './Auth.styles.scss';

const AuthRouter: React.FC = () => {
  const { user, isAuthorised } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isAuthorised) {
      navigate('/dash');
    }

    const authPath = generateAuthPath(user);
    if (location.pathname !== authPath) navigate(authPath);
  }, [isAuthorised, location.pathname, navigate, user]);

  return (
    <div className="auth-page">
      <Outlet />
    </div>
  );
};

export default AuthRouter;
